<template>
  <div class="QuestionsAndAnswers changeUEditor">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>

    <el-form-item label="参考答案" required>
        <uEditor :content="formData.referenceanswer" ref="referenceanswer" @getUEditorContent="getUEditorContent"></uEditor>
    </el-form-item>

    <el-form-item label="试题解析">
        <uEditor :content="formData.quesanalysis" ref="quesanalysis" @getUEditorContent="getUEditorQuesanalysisContent"></uEditor>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor4'
export default {
  name: 'QuestionsAndAnswers',
  props: ['formData'],
  data () {
    return {
        form: {
            subject: '',   // 试题题干Html
            referenceanswer: '', // 参考答案
            quesanalysis: '' // 试题解析
        },
    }
  },
  mounted () {
  },
  methods: {
    getUEditorContent(content) {
        this.formData.referenceanswer = content
    },
    getUEditorSubjectContent(content) {
        this.formData.subject = content
    },
    cancel() {  // 返回题库
        this.$bus.emit('topicCancel',1)
    },
    getUEditorQuesanalysisContent(content) {
        this.formData.quesanalysis = content
    },
    submit() {
        if (this.formData.referenceanswer == '') {
            this.$message.error('参考答案不能为空')
            return
        }
        // 传数据给父元素
        this.$emit('childSubmitFormApi', JSON.stringify(this.formData))
    }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      UEditor
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.changeUEditor {
    margin-left: -20px !important;
    /*.uEditor .edui-default .edui-editor, .uEditor .edui-default .edui-editor-iframeholder {*/
        /*width: 640px !important;*/
        /*height: 240px !important;*/
    /*}*/
    /*.uEditor .edui-default .edui-editor-iframeholder {*/
        /*height: 60% !important;*/
    /*}*/
    .el-form {
        margin-left: -20px !important;
    }
    .el-form-item__content {
        margin-left: 80px;
    }
    .el-form-item .el-form-item__label {
        width: 80px;
    }
    .del {
        right: -20px !important;
    }
    .el-radio {
        margin-right: 20px!important;
    }
    /*星号放在后面*/
    .el-form-item {
        .el-form-item__label {
            text-align: left
        }
        &.is-required {
            .el-form-item__label::after {
                content: "*";
                color: #F56C6C;
                margin-left: 4px;
            }
            .el-form-item__label::before {
                display: none;
            }
        }
    }
}
.QuestionsAndAnswers {
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .del {
        position: absolute;
        top: 0;
        right: -20px;
        cursor: pointer;
        img {
            width: 12px;
            height: 12px;
        }
    }
}
</style>
